import React, { Component } from 'react';
import { PageSection, IconCircleExclamation } from 'adc-ui-components';

import { kibanaLog } from '../../helpers/logger';

class GenericError extends Component {
  componentDidMount() {
    const { isErrorBoundary } = this.props;
    // todo, make this better
    if (!isErrorBoundary) {
      kibanaLog('generic_error');
    }
  }

  render() {
    return (
      <PageSection className="ui-grey page-section--banner">
        <IconCircleExclamation className="mb12 svg-icon--42" />

        <div className="mb24">
          <h1 className="heading2 mb6">Sorry, This Isn’t Working Right Now</h1>
          <p className="body2">
            {'Your equipment details are unavailable at this time. Please check back later to see if you\'re eligible for a device update.'}
          </p>
        </div>

        <a className="button button--primary" href="/">Back to My Account</a>
      </PageSection>
    );
  }
}

export default GenericError;
